import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import {
  detalheOportunidade,
  listarCdsOportunidadeSeller,
  cadastrarOportunidade,
  editarOportunidade,
  proximaOportunidade,
  disponibilizarOportunidade,
  buscarProdutoOportunidade,
  listarSellersOportunidade,
  duplicarOportunidade,
  buscarStatus,
} from "../../../../services/http/oportunidadeService";

import { useSnackBar } from "../../../../hooks/snackBar";

import {
  useFormik,
  getIn,
  FormikProvider,
  FieldArray,
  validateYupSchema,
  yupToFormErrors,
} from "formik";

import {
  editarOportunidadeValidator,
  emptyDetalheLoteDto,
  emptylocalizacaoCarga,
  formOportunidadeInitialState,
  mapDataToSent,
} from "./editarSellerOportunidadeValidator";

import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import "./styles.scss";
import {
  Box,
  Button,
  Divider,
  FormHelperText,
  Typography,
} from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import services from "../../../../services";
import {
  convertTextCurrencyToNumber,
  NumberFormatCurrency,
} from "../../../../util/NumberConvert";
import { listarProdutosSeller } from "../../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService";
import ButtonYesNo from "../../../../components/ButtonYesNo";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

const PerfilSellerEditarOportunidade = () => {
  const history = useHistory();
  const { id } = useParams();
  const { idSeller, idUser, ...dataSeller } = services.storage.getUser();
  const { addSnackBar } = useSnackBar();
  const [vendedores, setVendedores] = useState([]);
  const [cds, setCds] = useState([]);
  const [products, setProducts] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [statusDeal, setStatusDeal] = useState(1);

  const [pedidoMinimoAlterado, setPedidoMinimoAlterado] = useState([
    { oportunidadeIndex: 0, status: false },
  ]);
  const [produtoQuantidadeAlterado, setProdutoQuantidadeAlterado] = useState([
    { oportunidadeIndex: 0, produtosStatus: [false] },
  ]);

  const MOTIVOS_OPTIONS = [
    "Próximo ao vencimento",
    "Produto descontinuado",
    "Fora do padrão",
    "Promoção",
    "Ações Especiais",
    "Outro",
  ];

  const FRETE_OPTIONS = ["CIF", "FOB"];

  const formik = useFormik({
    initialValues: formOportunidadeInitialState(),
    validationSchema: editarOportunidadeValidator(statusDeal),
    validateOnMount: false,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (values) => {
      salvarAlteracao(values);
    },
  });

  const normalizeOpportunityPayload = (values) => {
    const payload = {
      ...values,
      motivoOfertaId: values?.motivoOferta ?? null,
      statusOfertaId: values?.statusOferta ?? null,
      detalheLoteDto: values?.detalheLoteDto?.map((detalhe) => {
        if (!detalhe) return detalhe;

        const detalheAtualizado = {
          ...detalhe,
          motivoOfertaId:
            detalhe?.motivoOferta ?? detalhe?.motivoOfertaId ?? null,
        };

        if ("motivoOferta" in detalheAtualizado) {
          delete detalheAtualizado.motivoOferta;
        }

        return detalheAtualizado;
      }),
    };

    delete payload.motivoOferta;
    delete payload.statusOferta;

    return payload;
  };

  const handleProvideOpportunity = async () => {
    var valido = await validarTotal(5 /* PendenteGreeners */);

    if (valido) {
      const payload = normalizeOpportunityPayload(formik.values);

      trackPromise(
        disponibilizarOportunidade(payload).then((res) => {
          if (!res.fail) {
            addSnackBar({
              message: "Oportunidade disponibilizada com sucesso ",
              info: "success",
              open: true,
            });

            history.push("/seller/oportunidade");

            return;
          }

          addSnackBar({
            message: "Erro ao tentar disponibilizar oportunidade",
            info: "error",
            open: true,
          });
        })
      ).catch((error) => {
        console.log(error);
      });
    }
  };

  const handleDuplicateOpportunity = async () => {
    const isValid = await formik.validateForm();
    if (Object.keys(isValid).length !== 0) {
      addSnackBar({
        message: "Preencha todos os campos obrigatórios",
        info: "warning",
        open: true,
      });

      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    trackPromise(
      duplicarOportunidade(id).then((res) => {
        if (!res.fail) {
          addSnackBar({
            message: "Oportunidade duplicada com sucesso ",
            info: "success",
            open: true,
          });

          history.push("/seller/oportunidade");

          return;
        }

        addSnackBar({
          message: "Erro ao duplicar oportunidade",
          info: "error",
          open: true,
        });
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const listarVendedores = (idEmpresa) => {
    trackPromise(
      listarSellersOportunidade().then((res) => {
        if (!res.data) {
          addSnackBar({
            message:
              "É necessario ter usuário cadastrado para o Seller selecionado",
            info: "warning",
            open: true,
          });
        }
        setVendedores(res.data);

        const findSeller = res.data.find(
          (item) => item.dadosEmpresaSellerId === idEmpresa
        );
        if (findSeller) {
          formik.setFieldValue(
            "cnpjSeller",
            `${findSeller.cnpj} - ${findSeller.nomeFantasia}`
          );
          formik.setFieldValue("vendedor", dataSeller.nome);
        }
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const listarCds = (idEmpresa) => {
    trackPromise(
      listarCdsOportunidadeSeller(idEmpresa).then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "É necessario ter CD cadastrado para o Seller selecionado",
            info: "warning",
            open: true,
          });
          return;
        }

        setCds(
          res.data.map((item) => ({
            id: item.id,
            cnpj: item.dadosCadastrais.cnpj,
            nomeFantasia: item.dadosCadastrais.nomeFantasia,
            cidade: item.dadosCadastrais.endereco.cidade,
            estado: item.dadosCadastrais.endereco.estado,
          }))
        );
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const pegarProximaOportunidade = () => {
    trackPromise(
      proximaOportunidade().then((res) => {
        var novoValues = { ...formik.values };
        novoValues.codigo = res.data;
        novoValues.dadosEmpresaSellerId = idSeller;
        novoValues.statusDeal = 1; // rascunho

        formik.setValues(novoValues);
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const listarSellers = () => {
    trackPromise(
      listarSellersOportunidade().then((res) => {
        if (!res.data) {
          addSnackBar({
            message:
              "É necessario cadastrar Seller para cadastrar oportunidade",
            info: "warning",
            open: true,
          });

          history.push("/oportunidade");
        }

        const findSeller = res.data.find(
          (item) => item.dadosEmpresaSellerId === idSeller
        );

        if (findSeller) {
          formik.setFieldValue(
            "cnpjSeller",
            `${findSeller.cnpj} - ${findSeller.nomeFantasia}`
          );

          formik.setFieldValue("nomeFantasia", findSeller.nomeFantasia);
          formik.setFieldValue("vendedor", dataSeller.nome);
          formik.setFieldValue("userId", idUser);
        }
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const listarStatus = () => {
    trackPromise(
      buscarStatus().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        }
        setStatusList(res.data);
      })
    ).catch(() => {
      setStatusList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };

  const listarProdutos = (dadosEmpresaSellerId) => {
    trackPromise(
      listarProdutosSeller(1, dadosEmpresaSellerId, 300).then((res) => {
        const data = res.data
          ? res?.data?.lista?.map((item) => ({
              label: item.gtin + " " + item.nomeProduto,
              id: item.gtin,
            }))
          : [];
        setProducts(data);
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const salvarAlteracao = (values) => {
    const totalOfProducts = values.detalheLoteDto.filter(
      (item) => item.gtinEan !== ""
    ).length;
    if (
      Number(values.totalSKU) !== totalOfProducts &&
      values.statusDeal !== 1
    ) {
      addSnackBar({
        message: "Todos os produtos dever ser preenchidos",
        info: "error",
        open: true,
      });
      return;
    }

    const formatedValues = mapDataToSent(values);

    var logica = {
      cadastrando: {
        endpoint: cadastrarOportunidade,
        mensagemSucesso: "Oportunidade cadastrada com sucesso",
        mensagemErro: "Erro ao tentar cadastrar nova oportunidade",
      },
      alterando: {
        endpoint: editarOportunidade,
        mensagemSucesso: "Oportunidade atualizada com sucesso",
        mensagemErro: "Erro ao tentar atualizar oportunidade",
      },
    }[id ? "alterando" : "cadastrando"];

    trackPromise(
      logica.endpoint(formatedValues).then((res) => {
        if (!res.fail) {
          addSnackBar({
            message: logica.mensagemSucesso,
            info: "success",
            open: true,
          });

          history.push("/seller/oportunidade");

          return;
        }

        addSnackBar({
          message: logica.mensagemErro,
          info: "error",
          open: true,
        });
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const formatarData = (data) => {
    const newData = new Date(data).toLocaleDateString();

    return newData;
  };

  async function buscarProdutos(produtos) {
    if (!formik.values.dadosEmpresaSellerId) {
      addSnackBar({
        message: "Selecione um Seller.",
        info: "error",
        open: true,
      });

      return;
    }

    if (produtos.some((a) => !a.gtinEan)) {
      addSnackBar({
        message: "Preencha o código de barras.",
        info: "error",
        open: true,
      });

      return;
    }

    var resultado = { ...formik.values };

    for (const produto of produtos) {
      const produtoResponse = await buscarProdutoOportunidade(
        resultado.dadosEmpresaSellerId,
        produto.gtinEan
      );

      if (!produtoResponse.data || produtoResponse.fail) return;

      resultado.detalheLoteDto[produto.indice] = {
        ...resultado.detalheLoteDto[produto.indice],
        statusDeal: resultado.statusDeal,
        gtinEan: produto.gtinEan,
        descricao:
          produtoResponse.data.descricao !== ""
            ? produtoResponse.data.descricao
            : "Não se aplica",
        categoria:
          produtoResponse.data.categoria !== ""
            ? produtoResponse.data.categoria
            : "Não se aplica",
        sku: produtoResponse.data.sku || "",
        descricaoLonga: produtoResponse.data.descricaoLonga || "Não se aplica",
        descricaoNcm: produtoResponse.data.descricaoNcm || "Não se aplica",
        precoMedio: produtoResponse.data.precoMedio || 0,
        gpc: produtoResponse.data.gpc || "Não se aplica",
        marca: produtoResponse.data.marca || "Não se aplica",
        fabricante: produtoResponse.data.fabricante || "Não se aplica",
        urlImagens: produtoResponse.data.produtoUrlImagem,
        alturaUnidade: produtoResponse.data.alturaUnidade,
        profundidadeUnidade: produtoResponse.data.profundidadeUnidade,
        larguraUnidade: produtoResponse.data.larguraUnidade,
        quantidadeUnidade: produtoResponse.data.quantidadeUnidade,
        pesoBrutoUnidade: produtoResponse.data.pesoBrutoUnidade,
        pesoLiquidoUnidade: produtoResponse.data.pesoLiquidoUnidade,
        volumeUnidade: produtoResponse.data.volumeUnidade,
        larguraCaixa: produtoResponse.data.larguraCaixa,
        alturaCaixa: produtoResponse.data.alturaCaixa,
        volumeCaixa: produtoResponse.data.volumeCaixa,
        profundidadeCaixa: produtoResponse.data.profundidadeCaixa,
        pesoBrutoCaixa: produtoResponse.data.pesoBrutoCaixa,
        pesoLiquidoCaixa: produtoResponse.data.pesoLiquidoCaixa,
        alturaPallet: produtoResponse.data.alturaPallet,
        larguraPallet: produtoResponse.data.larguraPallet,
        profundidadePallet: produtoResponse.data.profundidadePallet,
        pesoBrutoPallet: produtoResponse.data.pesoBrutoPallet,
        pesoLiquidoPallet: produtoResponse.data.pesoLiquidoPallet,
        volumePallet: produtoResponse.data.volumePallet,
        quantidadePorCaixa: Number(produtoResponse.data.quantidadePorCaixa),
        validade: produtoResponse.data.validade,
        lote: produtoResponse.data.lote || "",
        descontoAplicado:
          resultado?.detalheLoteDto[produto.indice]?.descontoAplicado ||
          Number(produtoResponse.data.descontoAplicado),
        caixaPallet: Number(produtoResponse.data.quantidadeDeCaixaPorPallet),
        quantidadeDeCaixaPorPallet: Number(
          produtoResponse.data.quantidadeDeCaixaPorPallet
        ),
        gtinDun14Caixa: produtoResponse.data.gtinDun14Caixa,
        ncm: produtoResponse.data.ncm || "Não se aplica",
        descricaoNcm: produtoResponse.data.ncm || "Não se aplica",
        //dataValidade: res.data?.dataValidade,
        localizacaoCarga: resultado?.detalheLoteDto[produto.indice]
          ?.localizacaoCarga.length
          ? resultado?.detalheLoteDto[produto.indice]?.localizacaoCarga
          : [emptylocalizacaoCarga],
      };
    }

    handleCalculateAutomaticFields(resultado);
    formik.setValues(resultado);
  }

  async function buscarProduto(gtinEan, indice) {
    await buscarProdutos([{ gtinEan, indice }]);
  }

  const [selecionarProduto, setSelecionarProduto] = useState({
    disponiveis: [],
    selecionado: null,
    aba: "produtos",
  });

  useEffect(() => {
    var novoSelecionarProduto = { ...selecionarProduto };

    if (formik.values.detalheLoteDto) {
      novoSelecionarProduto.disponiveis = formik.values.detalheLoteDto.map(
        (produto, indice) => ({
          indice,
          descricao: `#${indice + 1} ${produto.descricao}`,
        })
      );

      if (novoSelecionarProduto.selecionado) {
        novoSelecionarProduto.selecionado =
          novoSelecionarProduto.disponiveis.find(
            (a) => a.indice === novoSelecionarProduto.selecionado.indice
          );
      }
    } else {
      novoSelecionarProduto.disponiveis = [];
      novoSelecionarProduto.selecionado = null;
    }

    setSelecionarProduto(novoSelecionarProduto);
  }, [JSON.stringify(formik.values.detalheLoteDto)]);

  function setProduto(selecionado) {
    var novoSelecionarProduto = { ...selecionarProduto };
    novoSelecionarProduto.selecionado = selecionado;

    setSelecionarProduto(novoSelecionarProduto);
  }

  function setAba(aba) {
    var novoSelecionarProduto = { ...selecionarProduto };
    novoSelecionarProduto.aba = aba;

    setSelecionarProduto(novoSelecionarProduto);
  }

  const handleCalculatePalletsAvailable = (lote) => {
    let result = 0;

    if (!lote.estoqueDisponivelCaixas || !lote.caixaPallet) {
      result = 0;
    } else {
      result = Math.ceil(
        Math.max(
          Number(lote.estoqueDisponivelCaixas) / Number(lote.caixaPallet),
          0
        )
      );
    }

    return result;
  };

  const handleCalculateUnitPrice = (lote) => {
    return Math.max(0, lote.precoVenda_NF_PorCaixa / lote?.quantidadePorCaixa);
  };

  const handleChangeTotalCaixas = (e, indexLote) => {
    const lote = formik.values.detalheLoteDto[indexLote];

    formik.setFieldValue(
      `detalheLoteDto[${indexLote}].quantidadeTotalPallets`,
      handleCalculatePalletsAvailable(lote)
    );

    pedidoMinimoAlterado.forEach((item) => {
      if (item.oportunidadeIndex === indexLote && item.status === false) {
        formik.setFieldValue(
          `detalheLoteDto[${indexLote}].pedidoMinimo`,
          e.currentTarget.value
        );
      }
    });

    produtoQuantidadeAlterado[indexLote].produtosStatus.forEach(
      (localizacaoStatus, index) => {
        if (localizacaoStatus === false) {
          formik.setFieldValue(
            `detalheLoteDto[${indexLote}].localizacaoCarga[${index}].quantidade`,
            e.currentTarget.value
          );
        }
      }
    );
  };

  const handleCalculateAutomaticFields = async (values) => {
    const listCDS = await listarCdsOportunidadeSeller(
      values.dadosEmpresaSellerId
    );

    values.detalheLoteDto.forEach((item, index) => {
      item.quantidadeTotalPallets = handleCalculatePalletsAvailable(item);
      item.precoUnidade = handleCalculateUnitPrice(item);

      item.localizacaoCarga.forEach((location, locationIndex) => {
        const unidade = listCDS.data.find((cd) => cd.id === location.unidadeId);
        if (unidade) {
          location.cidade = unidade?.dadosCadastrais?.endereco?.cidade;
          location.estado = unidade?.dadosCadastrais?.endereco?.estado;
        }
      });
    });
  };

  const buscarOportunidade = () => {
    trackPromise(
      detalheOportunidade(id).then((res) => {
        if (res.fail) {
          throw new Error(res.errors);
        }
        listarCds(res.data.dadosEmpresaSellerId);

        const totalSKU =
          res.data.detalheLoteDto && res.data.detalheLoteDto.length > 0
            ? res.data.detalheLoteDto.length
            : 1;

        const values = {
          ...res.data,
          totalSKU: totalSKU,
          detalheLoteDto:
            res.data?.detalheLoteDto && res.data?.detalheLoteDto.length
              ? res.data?.detalheLoteDto
              : [emptyDetalheLoteDto],
        };

        values.detalheLoteDto.forEach((item, index) => {
          if (!item.localizacaoCarga || !item.localizacaoCarga.length) {
            values.detalheLoteDto[index]["localizacaoCarga"] = [
              emptylocalizacaoCarga,
            ];
          }
        });

        formik.setValues(values);
        setStatusDeal(res.data.statusDeal);
      })
    ).catch((error) => {
      addSnackBar({
        message: "Não foi possível encontrar a oportunidade.",
        info: "error",
        open: true,
      });
      console.log(error);
    });
  };

  const handleChangeTotalSKU = (value = 1) => {
    const detalheLoteDto = [...formik?.values?.detalheLoteDto];
    const totalThatMustExist = value;
    const totaThatCurrentlyExists = detalheLoteDto.length;
    const totalExecutions =
      totaThatCurrentlyExists - totalThatMustExist >= 1
        ? totaThatCurrentlyExists - totalThatMustExist
        : (totaThatCurrentlyExists - totalThatMustExist) * -1;

    if (totalThatMustExist > totaThatCurrentlyExists) {
      for (let index = 0; index < totalExecutions; index++) {
        detalheLoteDto.push(emptyDetalheLoteDto);
        produtoQuantidadeAlterado.push({
          oportunidadeIndex: produtoQuantidadeAlterado.length,
          produtosStatus: [false],
        });
        pedidoMinimoAlterado.push({
          oportunidadeIndex: pedidoMinimoAlterado.length,
          status: false,
        });
      }
    } else {
      for (let index = 0; index < totalExecutions; index++) {
        detalheLoteDto.pop();
        produtoQuantidadeAlterado.pop();
        pedidoMinimoAlterado.pop();
      }
    }
    formik.setFieldValue("detalheLoteDto", detalheLoteDto);
  };

  async function validarTotal(statusDeal) {
    try {
      await validateYupSchema(
        formik.values,
        editarOportunidadeValidator(statusDeal)
      );
    } catch (ex) {
      const erros = yupToFormErrors(ex);

      if (Object.keys(erros).length > 0) {
        // isso é pra trazer o foco pro produto com campos faltando
        if (
          erros.detalheLoteDto &&
          !erros.detalheLoteDto[selecionarProduto.selecionado?.indice]
        ) {
          for (var i = 0; i < erros.detalheLoteDto.length; i++) {
            if (erros.detalheLoteDto[i]) {
              var novoSelecionarProduto = { ...selecionarProduto };
              novoSelecionarProduto.selecionado =
                novoSelecionarProduto.disponiveis.find((a) => a.indice === i);

              setSelecionarProduto(novoSelecionarProduto);
              break;
            }
          }
        }

        addSnackBar({
          message: "Preencha todos os campos obrigatórios",
          info: "warning",
          open: true,
        });

        window.scrollTo({ top: 0, behavior: "smooth" });
        formik.setErrors(erros);
        return false;
      }
    }

    return true;
  }

  const getFormikErrorsOportunidade = (
    index,
    property,
    origin = "detalheLoteDto"
  ) => getIn(formik.errors, `${origin}[${index}].${property}`);

  const getInitialLabelForUnidade = (list, id) => {
    const cnpj = list.find((item) => item.id === id)?.cnpj || "";
    const nomeFantasia =
      list.find((item) => item.id === id)?.nomeFantasia || "";

    if (cnpj && nomeFantasia) {
      return `${cnpj} - ${nomeFantasia}`;
    }
    return "";
  };

  useEffect(() => {
    listarSellers();
    listarStatus();

    if (id) {
      buscarOportunidade(id);
    } else {
      pegarProximaOportunidade();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (formik.values.dadosEmpresaSellerId) {
      listarVendedores(formik.values.dadosEmpresaSellerId);
      listarCds(formik.values.dadosEmpresaSellerId);
      listarProdutos(formik.values.dadosEmpresaSellerId);

      var produtos = formik.values.detalheLoteDto
        .filter((produto) => produto.gtinEan)
        .map((produto, indice) => ({
          gtinEan: produto.gtinEan,
          indice,
        }));

      buscarProdutos(produtos);
    }
  }, [formik.values.dadosEmpresaSellerId]);

  useEffect(() => {
    if (formik.values.codigo) {
      var produtos = formik.values.detalheLoteDto
        .filter((produto) => produto.gtinEan)
        .map((produto, indice) => ({
          gtinEan: produto.gtinEan,
          indice,
        }));

      buscarProdutos(produtos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.codigo]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row mt20 mb30">
        <div className="col-sm-12 col-md-12 col-lg-12 titulo">
          Oportunidades
        </div>
        <div className="col-sm-12 col-md-12 col-lg-12 font-thin">
          <strong>Detalhe da oportunidade</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3">
          ID da Oportunidade <br />
          <strong>{formik?.values?.codigo?.toString().padStart(6, "0")}</strong>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          Data de Abertura <br />
          <strong>{formatarData(formik.values.dataAbertura)}</strong>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          Status da Oportunidade * <br />
          <strong>
            {statusList.find((item) => item.id === formik.values.statusDeal)
              ?.nome || "Rascunho"}
          </strong>
        </div>
      </div>

      <div className="row mt30 mb20">
        <div className="col-sm-12 col-md-12 col-lg-12 body">
          <strong>Dados do Seller</strong>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <FormControl>
            <TextField
              disabled
              label="CNPJ Seller"
              type="text"
              size="small"
              id="cnpjSeller"
              name="cnpjSeller"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={formik.values.cnpjSeller}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <TextField
              disabled
              label="Vendedor"
              type="text"
              size="small"
              id="vendedor"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={formik.values.vendedor}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-8 col-md-8 col-lg-8">
          <FormControl>
            <TextField
              label="Nome da Oportunidade"
              type="text"
              size="small"
              id="nomeOportunidade"
              name="nomeOportunidade"
              variant="outlined"
              value={formik.values.nomeOportunidade}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <FormControl>
            <TextField
              required
              label="#SKUs nessa Oportunidade"
              type="number"
              InputProps={{ inputProps: { min: 1, defaultValue: 1 } }}
              size="small"
              id="totalSKU"
              name="totalSKU"
              variant="outlined"
              value={formik.values.totalSKU}
              onChange={(e) => {
                formik.handleChange(e);
                handleChangeTotalSKU(Number(e.currentTarget.value));
              }}
            />
          </FormControl>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <FormControl>
            <Autocomplete
              className="select w100p"
              options={selecionarProduto.disponiveis}
              onChange={(e, produto) => setProduto(produto)}
              getOptionLabel={(produto) => produto.descricao}
              value={selecionarProduto.selecionado}
              noOptionsText={"Sem Opções"}
              renderInput={(params) => {
                return (
                  <TextField {...params} variant="outlined" label="Produto" />
                );
              }}
            />
          </FormControl>
        </div>
      </div>

      {formik.values?.detalheLoteDto[
        selecionarProduto?.selecionado?.indice
      ] && (
        <>
          <ul className="nav nav-tabs">
            <li className="nav-item nav-selected">
              <a className="nav-link" aria-current="page" href="#">
                <Typography className="fontgreen" variant="subtitle1">
                  Detalhe do(s) Produto(s)
                </Typography>
              </a>
            </li>
          </ul>

          <FormikProvider value={formik}>
            {selecionarProduto.aba === "produtos" && (
              <>
                <div className="row mt10 ml5">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Dados Cadastrais
                  </Typography>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <Autocomplete
                        inputId={`detalheLoteDto[${selecionarProduto.selecionado.indice}].gtinEan`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].gtinEan`}
                        className="select w100p"
                        noOptionsText="Sem Opções"
                        options={products}
                        onChange={(_, value) => {
                          if (value) {
                            formik.setFieldValue(
                              `detalheLoteDto[${selecionarProduto.selecionado.indice}].gtinEan`,
                              value.id
                            );
                            buscarProduto(
                              value.id,
                              selecionarProduto.selecionado.indice
                            );
                          }
                        }}
                        getOptionLabel={(option) => option.label || "selecione"}
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].gtinEan
                        }
                        inputValue={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].gtinEan
                        }
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              type="text"
                              className="solid"
                              variant="outlined"
                              error={getFormikErrorsOportunidade(
                                selecionarProduto.selecionado.indice,
                                "gtinEan"
                              )}
                              label="GTIN/EAN (Código de Barras) *"
                            />
                          );
                        }}
                      />
                      {getFormikErrorsOportunidade(
                        selecionarProduto.selecionado.indice,
                        "gtinEan"
                      ) && <FormHelperText>Campo obrigatório</FormHelperText>}
                    </FormControl>
                  </div>
                  <div className="col-sm-8 col-md-8 col-lg-8">
                    <FormControl>
                      <TextField
                        disabled
                        label="Descrição"
                        type="text"
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].descricao`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].descricao`}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].descricao
                        }
                        onChange={formik.handleChange}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "descricao"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "descricao"
                        )}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <img
                      alt=""
                      src={
                        formik.values.detalheLoteDto[
                          selecionarProduto.selecionado.indice
                        ].urlImagens
                      }
                      style={{
                        width: "auto",
                        height: "300px",
                        borderStyle: "solid",
                      }}
                    />
                  </div>
                  <div className="col-sm-8 col-md-8 col-lg-8">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <FormControl>
                          <TextField
                            id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].descricaoLonga`}
                            name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].descricaoLonga`}
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            size="small"
                            multiline
                            rows={6}
                            disabled
                            label="Descrição Longa"
                            onChange={formik.handleChange}
                            value={
                              formik.values.detalheLoteDto[
                                selecionarProduto.selecionado.indice
                              ].descricaoLonga
                            }
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormControl>
                          <TextField
                            disabled
                            label="Categoria"
                            type="text"
                            size="small"
                            variant="outlined"
                            id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].categoria`}
                            name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].categoria`}
                            InputLabelProps={{ shrink: true }}
                            value={
                              formik.values.detalheLoteDto[
                                selecionarProduto.selecionado.indice
                              ].categoria
                            }
                            onChange={formik.handleChange}
                            error={Boolean(
                              getFormikErrorsOportunidade(
                                selecionarProduto.selecionado.indice,
                                "categoria"
                              )
                            )}
                            helperText={getFormikErrorsOportunidade(
                              selecionarProduto.selecionado.indice,
                              "categoria"
                            )}
                          />
                        </FormControl>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormControl>
                          <TextField
                            disabled
                            label="Marca"
                            type="text"
                            size="small"
                            variant="outlined"
                            value={
                              formik.values.detalheLoteDto[
                                selecionarProduto.selecionado.indice
                              ].marca
                            }
                            id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].marca`}
                            name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].marca`}
                            InputLabelProps={{ shrink: true }}
                            onChange={formik.handleChange}
                            error={Boolean(
                              getFormikErrorsOportunidade(
                                selecionarProduto.selecionado.indice,
                                "marca"
                              )
                            )}
                            helperText={getFormikErrorsOportunidade(
                              selecionarProduto.selecionado.indice,
                              "marca"
                            )}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                          <TextField
                            disabled
                            label="GTIN / DUN"
                            id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].gtinDun14Caixa`}
                            name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].gtinDun14Caixa`}
                            type="text"
                            size="small"
                            variant="outlined"
                            value={
                              formik.values.detalheLoteDto[
                                selecionarProduto.selecionado.indice
                              ].gtinDun14Caixa
                            }
                            onChange={formik.handleChange}
                            InputLabelProps={{ shrink: true }}
                            error={Boolean(
                              getFormikErrorsOportunidade(
                                selecionarProduto.selecionado.indice,
                                "gtinDun14Caixa"
                              )
                            )}
                            helperText={getFormikErrorsOportunidade(
                              selecionarProduto.selecionado.indice,
                              "gtinDun14Caixa"
                            )}
                          />
                        </FormControl>
                      </div>
                      <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                          <TextField
                            disabled
                            label="NCM (Nomenclatura Comum do Mercosul)"
                            type="text"
                            size="small"
                            id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].ncm`}
                            name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].ncm`}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={
                              formik.values.detalheLoteDto[
                                selecionarProduto.selecionado.indice
                              ].ncm
                            }
                            onChange={formik.handleChange}
                            error={Boolean(
                              getFormikErrorsOportunidade(
                                selecionarProduto.selecionado.indice,
                                "ncm"
                              )
                            )}
                            helperText={getFormikErrorsOportunidade(
                              selecionarProduto.selecionado.indice,
                              "ncm"
                            )}
                          />
                        </FormControl>
                      </div>
                      <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                          <TextField
                            disabled
                            label="GPC (Classificação Global de Produtos)"
                            type="text"
                            size="small"
                            id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].gpc`}
                            name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].gpc`}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={
                              formik.values.detalheLoteDto[
                                selecionarProduto.selecionado.indice
                              ].gpc
                            }
                            onChange={formik.handleChange}
                            error={Boolean(
                              getFormikErrorsOportunidade(
                                selecionarProduto.selecionado.indice,
                                "gpc"
                              )
                            )}
                            helperText={getFormikErrorsOportunidade(
                              selecionarProduto.selecionado.indice,
                              "gpc"
                            )}
                          />
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt20 ml5">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Dados do Produto / Oferta
                  </Typography>
                </div>
                <div className="row">
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl
                      error={Boolean(
                        getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "motivoOferta"
                        )
                      )}
                    >
                      <InputLabel id="demo-simple-select-helper-label">
                        Motivo da Oferta *
                      </InputLabel>
                      <Select
                        className="select"
                        variant="outlined"
                        label="Motivo da Oferta *"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].motivoOferta`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].motivoOferta`}
                        MenuProps={MenuProps}
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].motivoOferta
                        }
                        onChange={formik.handleChange}
                      >
                        <MenuItem value={""}>Selecione</MenuItem>
                        {MOTIVOS_OPTIONS.map((item) => (
                          <MenuItem value={item} key={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>

                      {getIn(
                        formik.errors,
                        `detalheLoteDto[${selecionarProduto.selecionado.indice}].motivoOferta`
                      ) && <FormHelperText>Campo obrigatório</FormHelperText>}
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        disabled={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ]?.motivoOferta?.toLowerCase() !== "outro"
                        }
                        label="Outro:"
                        type="text"
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].outro`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].outro`}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ]?.outro
                        }
                        onChange={formik.handleChange}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "outro"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "outro"
                        )}
                      />
                    </FormControl>
                  </div>

                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        label="Data de Validade"
                        type="date"
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].dataValidade`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].dataValidade`}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].dataValidade
                        }
                        onChange={formik.handleChange}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "dataValidade"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "dataValidade"
                        )}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                      <TextField
                        label="Estoque Disponível (caixas) *"
                        type="number"
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].estoqueDisponivelCaixas`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].estoqueDisponivelCaixas`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].estoqueDisponivelCaixas
                        }
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          handleChangeTotalCaixas(
                            e,
                            selecionarProduto.selecionado.indice
                          );
                        }}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "estoqueDisponivelCaixas"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "estoqueDisponivelCaixas"
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                      <TextField
                        disabled
                        label="Caixas por Pallet"
                        type="number"
                        InputProps={{
                          inputProps: { min: 1, defaultValue: 1 },
                        }}
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].caixaPallet`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].caixaPallet`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].caixaPallet
                        }
                        onChange={formik.handleChange}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "caixaPallet"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "caixaPallet"
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                      <TextField
                        label="Pallets Disponíveis"
                        type="text"
                        size="small"
                        disabled
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].quantidadeTotalPallets`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].quantidadeTotalPallets`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].quantidadeTotalPallets
                        }
                        onChange={formik.handleChange}
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "quantidadeTotalPallets"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "quantidadeTotalPallets"
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                      <TextField
                        label={"Pedido Mínimo (Caixas)"}
                        type="number"
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].pedidoMinimo`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].pedidoMinimo`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].pedidoMinimo
                        }
                        onChange={(e) => {
                          formik.handleChange(e);
                          const listPedidoMinimoAlterado = [
                            ...pedidoMinimoAlterado,
                          ];
                          listPedidoMinimoAlterado[
                            selecionarProduto.selecionado.indice
                          ].status = true;

                          setPedidoMinimoAlterado(listPedidoMinimoAlterado);
                        }}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "pedidoMinimo",
                            "detalheLoteDto"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "pedidoMinimo",
                          "detalheLoteDto"
                        )}
                      />
                    </FormControl>
                  </div>
                </div>

                <FieldArray
                  name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga`}
                  render={(localizacaoCargaHelpers) => (
                    <>
                      {formik?.values?.detalheLoteDto[
                        selecionarProduto.selecionado.indice
                      ]?.localizacaoCarga?.map(
                        (localizacao, localizacaoIndex) => (
                          <div className="row" key={localizacaoIndex}>
                            <div className="col-sm-3 col-md-3 col-lg-3">
                              <FormControl>
                                <TextField
                                  label="Localização"
                                  size="small"
                                  id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].localizacao`}
                                  name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].localizacao`}
                                  variant="outlined"
                                  value={localizacao.localizacao}
                                  InputLabelProps={{
                                    shrink: !!localizacao.localizacao,
                                  }}
                                  onChange={formik.handleChange}
                                />
                              </FormControl>
                            </div>
                            <div className="col-sm-3 col-md-3 col-lg-3">
                              <FormControl>
                                <TextField
                                  label="Cidade"
                                  size="small"
                                  id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].cidade`}
                                  name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].cidade`}
                                  variant="outlined"
                                  InputLabelProps={{ shrink: true }}
                                  value={localizacao.cidade}
                                  onChange={formik.handleChange}
                                />
                              </FormControl>
                            </div>
                            <div className="col-sm-1 col-md-1 col-lg-1">
                              <FormControl>
                                <TextField
                                  label="UF"
                                  size="small"
                                  id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].estado`}
                                  name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].estado`}
                                  variant="outlined"
                                  InputLabelProps={{ shrink: true }}
                                  value={localizacao.estado}
                                  onChange={formik.handleChange}
                                />
                              </FormControl>
                            </div>
                            <div className="col-sm-3 col-md-3 col-lg-3">
                              <FormControl>
                                <TextField
                                  label="Quantidade (caixas) *"
                                  type="number"
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  InputProps={{
                                    inputProps: {
                                      min: 0,
                                      defaultValue:
                                        formik.values.estoqueDisponivelCaixas,
                                    },
                                  }}
                                  id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].quantidade`}
                                  name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].quantidade`}
                                  variant="outlined"
                                  error={getIn(
                                    formik.errors,
                                    `detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].quantidade`
                                  )}
                                  helperText={getIn(
                                    formik.errors,
                                    `detalheLoteDto[${selecionarProduto.selecionado.indice}].localizacaoCarga[${localizacaoIndex}].quantidade`
                                  )}
                                  value={localizacao.quantidade}
                                  onChange={formik.handleChange}
                                  onBlur={(e) => {
                                    const produtosQuantidade = [
                                      ...produtoQuantidadeAlterado,
                                    ];
                                    produtosQuantidade[
                                      selecionarProduto.selecionado.indice
                                    ].produtosStatus[localizacaoIndex] = true;
                                    setProdutoQuantidadeAlterado(
                                      produtosQuantidade
                                    );
                                  }}
                                />
                              </FormControl>
                            </div>
                            <div className="col-sm-1 col-md-1 col-lg-1">
                              {localizacaoIndex !== 0 && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    height: "100%",
                                  }}
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  <Button
                                    variant="text"
                                    type="button"
                                    size="small"
                                    style={{
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      localizacaoCargaHelpers.remove(
                                        localizacaoIndex
                                      );

                                      const tempArray = [
                                        ...produtoQuantidadeAlterado,
                                      ];
                                      tempArray[
                                        selecionarProduto.selecionado.indice
                                      ].produtosStatus.splice(
                                        localizacaoIndex,
                                        1
                                      );
                                      setProdutoQuantidadeAlterado(tempArray);
                                    }}
                                  >
                                    Remover origem
                                  </Button>
                                </Box>
                              )}
                            </div>
                          </div>
                        )
                      )}
                      <div className="row mb20">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                          <Button
                            variant="text"
                            type="button"
                            size="small"
                            style={{ textDecoration: "underline" }}
                            onClick={() => {
                              localizacaoCargaHelpers.push(
                                emptylocalizacaoCarga
                              );
                              produtoQuantidadeAlterado[
                                selecionarProduto.selecionado.indice
                              ].produtosStatus.push(false);
                            }}
                          >
                            Adicionar origem
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                />

                <Divider />

                <div className="row mt20">
                  <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                      <TextField
                        label="Desconto Aplicado (%)"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 0,
                            max: 100,
                          },
                        }}
                        InputLabelProps={{
                          shrink:
                            formik.values.detalheLoteDto[
                              selecionarProduto.selecionado.indice
                            ].descontoAplicado !== null &&
                            formik.values.detalheLoteDto[
                              selecionarProduto.selecionado.indice
                            ].descontoAplicado !== "",
                        }}
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].descontoAplicado`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].descontoAplicado`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].descontoAplicado
                        }
                        onChange={formik.handleChange}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "descontoAplicado"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "descontoAplicado"
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                      <TextField
                        label="Preço de Venda - NF (por caixa) *"
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].precoVenda_NF_PorCaixa`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].precoVenda_NF_PorCaixa`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ]?.precoVenda_NF_PorCaixa
                        }
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          formik.setFieldValue(
                            `detalheLoteDto[${selecionarProduto.selecionado.indice}].precoUnidade`,
                            Math.max(
                              0,
                              convertTextCurrencyToNumber(
                                e.currentTarget.value
                              ) /
                                formik.values.detalheLoteDto[
                                  selecionarProduto.selecionado.indice
                                ]?.quantidadePorCaixa || 0
                            )
                          );
                        }}
                        InputProps={{
                          inputComponent: NumberFormatCurrency,
                        }}
                        InputLabelProps={{
                          shrink:
                            formik.values.detalheLoteDto[
                              selecionarProduto.selecionado.indice
                            ].precoVenda_NF_PorCaixa !== null,
                        }}
                        error={Boolean(
                          getFormikErrorsOportunidade(
                            selecionarProduto.selecionado.indice,
                            "precoVenda_NF_PorCaixa"
                          )
                        )}
                        helperText={getFormikErrorsOportunidade(
                          selecionarProduto.selecionado.indice,
                          "precoVenda_NF_PorCaixa"
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                      <TextField
                        disabled
                        label={`Quantidade por Caixa`}
                        type="number"
                        InputProps={{
                          inputProps: { min: 0 },
                        }}
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].quantidadePorCaixa`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].quantidadePorCaixa`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].quantidadePorCaixa
                        }
                        onChange={formik.handleChange}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                      <TextField
                        label={`Preço Unitário`}
                        disabled
                        size="small"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].precoUnidade`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].precoUnidade`}
                        variant="outlined"
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].precoUnidade
                        }
                        onChange={formik.handleChange}
                        InputLabelProps={{
                          shrink:
                            formik.values.detalheLoteDto[
                              selecionarProduto.selecionado.indice
                            ].precoUnidade !== null,
                        }}
                        InputProps={{
                          inputComponent: NumberFormatCurrency,
                        }}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                      <InputLabel id="demo-simple-select-helper-label">
                        Tipo de Frete
                      </InputLabel>
                      <Select
                        className="select"
                        variant="outlined"
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].tipoFrete`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].tipoFrete`}
                        MenuProps={MenuProps}
                        value={
                          formik.values?.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ]?.tipoFrete
                        }
                        onChange={formik.handleChange}
                      >
                        <MenuItem value={""}>Selecione</MenuItem>
                        {FRETE_OPTIONS.map((item) => (
                          <MenuItem value={item} key={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <FormControl>
                      <TextField
                        id={`detalheLoteDto[${selecionarProduto.selecionado.indice}].observacoes`}
                        name={`detalheLoteDto[${selecionarProduto.selecionado.indice}].observacoes`}
                        variant="outlined"
                        InputLabelProps={{
                          shrink:
                            formik.values.detalheLoteDto[
                              selecionarProduto.selecionado.indice
                            ].observacoes,
                        }}
                        type="text"
                        size="small"
                        multiline
                        rows={6}
                        label="Observações"
                        onChange={formik.handleChange}
                        value={
                          formik.values.detalheLoteDto[
                            selecionarProduto.selecionado.indice
                          ].observacoes
                        }
                      />
                    </FormControl>
                  </div>
                </div>
              </>
            )}
          </FormikProvider>
        </>
      )}

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        className="mt40"
      >
        <div className="col-sm-8 col-md-8 col-lg-8 buttons">
          <ButtonYesNo
            buttonText="CANCELAR"
            buttonClass="col-sm-6 col-md-6 col-lg-6 buton-white-black-border"
            alertDescription="Deseja realmente descartar as alterações realizadas?"
            onConfirm={() => history.push("/seller/oportunidade")}
          />

          <div className="ml5"></div>
          <button
            type="submit"
            className="col-sm-6 col-md-6 col-lg-6 button-black "
            onClick={async () => await validarTotal(statusDeal)}
          >
            SALVAR
          </button>
        </div>
      </Box>

      {id && (
        <>
          {statusList.find((item) => item.nome.toLowerCase() === "rascunho")
            ?.id === formik.values.statusDeal && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              className="mt10"
            >
              <div className="col-sm-8 col-md-8 col-lg-8 flex flex-end buttons ">
                <button
                  type="button"
                  className="col-sm-12 col-md-12 col-lg-12 buton-green "
                  onClick={() => handleProvideOpportunity()}
                >
                  DISPONIBILIZAR OPORTUNIDADE
                </button>
              </div>
            </Box>
          )}
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className="mt10"
          >
            <div className="col-sm-8 col-md-8 col-lg-8 flex flex-end buttons ">
              <button
                type="button"
                className="col-sm-12 col-md-12 col-lg-12 buton-white-black-border "
                onClick={handleDuplicateOpportunity}
              >
                DUPLICAR OPORTUNIDADE
              </button>
            </div>
          </Box>
        </>
      )}
    </form>
  );
};

export default PerfilSellerEditarOportunidade;
